export default __webpack_public_path__ + "static/media/is_headshot.9215e906.jpg";